/** Remove tags repetidas por id (evita acumulação visual na lista/drawer). */
export function dedupeTagsById(tags) {
	if (!Array.isArray(tags) || tags.length === 0) return [];
	const seen = new Set();
	const out = [];
	for (const tag of tags) {
		if (!tag) continue;
		const id = tag.id ?? tag.tagId;
		const key = id != null ? `id:${id}` : `name:${String(tag.name || "").toLowerCase()}`;
		if (seen.has(key)) continue;
		seen.add(key);
		out.push(tag);
	}
	return out;
}

/**
 * Normaliza contact.tags a partir de tags e/ou contactTags (Go/Node).
 * Sempre devolve array único por id.
 */
export function normalizeContactTags(contact) {
	if (!contact) return contact;

	const collected = [];
	if (Array.isArray(contact.tags)) {
		collected.push(...contact.tags);
	}
	if (Array.isArray(contact.contactTags)) {
		for (const ct of contact.contactTags) {
			if (!ct) continue;
			const tag = ct.Tag || ct.tag || (ct.name != null ? ct : null);
			if (tag) collected.push(tag);
		}
	}

	return {
		...contact,
		tags: dedupeTagsById(collected),
	};
}
